(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Erdeniz — koleksiyon gridindeki erdeniz kartlarında galeri okları */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-grid .ec-card-arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const gallery = btn.closest('.erdeniz-card-gallery');
    if (!gallery) return;
    const imgs = gallery.querySelectorAll('img[data-img-index]');
    const total = parseInt(gallery.dataset.total) || imgs.length;
    const current = parseInt(gallery.dataset.current) || 0;
    const dir = parseInt(btn.dataset.dir) || 1;
    const next = (current + dir + total) % total;
    imgs.forEach((img) => {
      img.style.opacity = parseInt(img.getAttribute('data-img-index')) === next ? '1' : '0';
    });
    gallery.dataset.current = next;
  });

  /* Erdeniz — hover'da sonraki görsel önizleme (standart kartların
     show_second_image_on_hover davranışı ile aynı) */
  document.addEventListener('mouseover', (e) => {
    const gallery = e.target.closest('.product-grid .erdeniz-card-gallery');
    if (!gallery || gallery.dataset.hoverPreview === '1') return;
    const total = parseInt(gallery.dataset.total) || 0;
    if (total < 2) return;
    gallery.dataset.hoverPreview = '1';
    const next = (parseInt(gallery.dataset.current) || 0) + 1;
    const show = next % total;
    gallery.querySelectorAll('img[data-img-index]').forEach((img) => {
      img.style.opacity = parseInt(img.getAttribute('data-img-index')) === show ? '1' : '0';
    });
    gallery.dataset.current = show;
  });

  document.addEventListener('mouseout', (e) => {
    const gallery = e.target.closest('.product-grid .erdeniz-card-gallery');
    if (!gallery) return;
    if (e.relatedTarget && gallery.contains(e.relatedTarget)) return;
    gallery.dataset.hoverPreview = '';
    gallery.querySelectorAll('img[data-img-index]').forEach((img) => {
      img.style.opacity = parseInt(img.getAttribute('data-img-index')) === 0 ? '1' : '0';
    });
    gallery.dataset.current = 0;
  });

  /* Erdeniz — koleksiyon gridinde swatch hover'da renk görseli önizleme */
  document.addEventListener('mouseover', (e) => {
    const dot = e.target.closest('.product-grid .erdeniz-swatch-dot[data-swatch-img]');
    if (!dot) return;
    const swatchUrl = dot.getAttribute('data-swatch-img');
    if (!swatchUrl) return;
    const card = dot.closest('product-card');
    if (!card) return;
    const wrap = card.querySelector('.ec-card-imgs');
    if (!wrap) return;
    let preview = wrap.querySelector('.ec-swatch-preview');
    if (!preview) {
      preview = document.createElement('img');
      preview.className = 'ec-swatch-preview';
      preview.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center center;z-index:3;';
      wrap.appendChild(preview);
    }
    if (preview.getAttribute('data-url') !== swatchUrl) {
      preview.setAttribute('data-url', swatchUrl);
      preview.src = swatchUrl;
    }
    preview.style.display = 'block';
  });

  document.addEventListener('mouseout', (e) => {
    const dot = e.target.closest('.product-grid .erdeniz-swatch-dot');
    if (!dot) return;
    if (e.relatedTarget && dot.contains(e.relatedTarget)) return;
    const card = dot.closest('product-card');
    if (!card) return;
    const preview = card.querySelector('.ec-swatch-preview');
    if (preview) preview.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();
})();
